import component_icon from "../../../assets/images/component_icon.png"
import page_setting_icon from "../../../assets/images/page_setting_icon.png"
import component_active_icon from "../../../assets/images/component_active_icon.png"
import setting_active_icon from "../../../assets/images/setting_acive_icon.png"
import { pageLayout,pageLayoutOld,pageLayoutComponent, allState, highLevelState, bigScreenState, baseState, global } from "./menuComponent/index.js"

export default {
  menu: {
    name: "菜单",
    children: [
      {
        type: "pageLayout",
        name: "布局",
        isActive: false,
        icon: component_icon,
        activeIcon: component_active_icon,
        children: Object.keys(pageLayout).map(key => pageLayout[key])
      },
      {
        type: "pageLayout",
        name: "布局",
        isOldPageLayout: true,
        isActive: false,
        icon: component_icon,
        activeIcon: component_active_icon,
        children: Object.keys(pageLayoutOld).map(key => pageLayoutOld[key])
      },
      {
        type: "pageLayout",
        name: "布局组件",
        isActive: false,
        icon: component_icon,
        activeIcon: component_active_icon,
        children: Object.keys(pageLayoutComponent).map(key => pageLayoutComponent[key])
      },
      {
        type: "baseElement",
        name: "基础",
        isActive: false,
        icon: component_icon,
        activeIcon: component_active_icon,
        children: Object.keys(baseState).map(key => baseState[key])
      },
      {
        type: "element",
        name: "组件",
        isActive: false,
        icon: component_icon,
        activeIcon: component_active_icon,
        children: Object.keys(allState).map(key => allState[key])
      },
      {
        type: "chart",
        name: "图表",
        icon: page_setting_icon,
        activeIcon: setting_active_icon,
        isActive: false,
        children: Object.keys(bigScreenState).map(key => bigScreenState[key])
      },
      {
        type: "global",
        name: "全局",
        isActive: false,
        icon: component_icon,
        activeIcon: component_active_icon,
        children: Object.keys(global).map(key => global[key]),
        enable(params) {
          return !params.isSubHeadPage
        }
      },
      {
        type: "highLevel",
        name: "高级组件",
        isActive: false,
        icon: component_icon,
        activeIcon: component_active_icon,
        // enable(params) {
        //   return params.admin
        // },
        children: Object.keys(highLevelState).map(key => highLevelState[key])
      }
    ],
    appId: []
  }
}
